interface MessageBoxState {
  isVisible: boolean
  message: string
  title?: string
  okText?: string
  cancelText?: string
  onOk?: () => void
  onCancel?: () => void
}

export const useDialog = () => {
  const state = useState<MessageBoxState>('messageBox', () => ({
    isVisible: false,
    message: '',
    title: '',
    okText: '확인',
    cancelText: '취소',
    onOk: undefined,
    onCancel: undefined,
  }))

  const open = (args: MessageBoxState) => {
    state.value = args
    // 스크롤 방지
    if (typeof document !== 'undefined' && args.isVisible) {
      document.body.style.overflow = 'hidden'
    }
  }

  const close = () => {
    state.value.isVisible = false
    // 스크롤 복원
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
    }
  }

  return {
    state,
    open,
    close,
  }
}
